// 计算每个版本的最优力度 - 优惠券优先
export const computeBestDiscount = (res, data) => {
    
    // 格式折扣文案
    const formatDiscountText = (discount) => {
        return !Boolean(discount) ? "" : discount >= 1 ? `-$${discount}` : `${((1 - Number(discount)) * 100).toFixed(0)}% OFF`;
    }

    let obj_data = {};
    // 有试用天数的优惠券优先
    if (Object.keys(data.coupon_info).length > 0 && data.coupon_info.trial_days > 0) {
        // 优惠券
        let price = Number(data.coupon_info.discount_price);
        let o_price = Number(data.price);
        obj_data = {
            price,
            o_price,
            trial_days: data.coupon_info.trial_days,
            period: Number(data.coupon_info.discount_period),
            expires_in: data.coupon_info.expires_in,
            rate: Number(data.coupon_info.rate),
            code: data.coupon_info.code,
            rateText: formatDiscountText(Number(data.coupon_info.rate)),
            save_price: Number((o_price - price).toFixed(2)),
        };
    } else if (Object.keys(data.coupon_info).length > 0 || Boolean(data?.discount_rate)) {
        // 无试用 需计算活动和优惠券的力度
        let c_price = Number(data.coupon_info?.discount_price) || -1;
        let d_price = Number(data?.discount_price) || -1;
        let o_price = Number(data.price);
        let price = data.price;
        let rate = "";
        let period = 0;
        let expires_in = 0;
        let code = null;
        let rateText = "";
        if (c_price !== -1 && d_price !== -1) {
            price = c_price > d_price ? d_price : c_price;
            rate = c_price > d_price ? data.discount_rate : data.coupon_info.rate;
            period = c_price > d_price ? data.discount_period : data.coupon_info.discount_period;
            expires_in = c_price > d_price ? data.discount_exp : data.coupon_info.expires_in;
            code = c_price > d_price ? null : data.coupon_info.code;
            rateText = c_price > d_price ? formatDiscountText(Number(data.discount_rate)) : formatDiscountText(Number(data.coupon_info.rate));
        } else if (c_price !== -1 && d_price === -1) {
            price = c_price;
            rate = data.coupon_info.rate;
            period = data.coupon_info.discount_period;
            expires_in = data.coupon_info.expires_in;
            code = data.coupon_info.code;
            rateText = formatDiscountText(Number(data.coupon_info.rate));
        } else if (c_price === -1 && d_price !== -1) {
            price = d_price;
            rate = data.discount_rate;
            period = data.discount_period;
            expires_in = data.discount_exp;
            code = null;
            rateText = formatDiscountText(Number(data.discount_rate));
        } else {
            price = data.price;
            rate = "";
            period = 0;
            expires_in = 0;
            code = null;
            rateText = "";
        }
        obj_data = {
            price: Number(price),
            o_price,
            trial_days: res.trial_days || 0,
            rate: Number(rate),
            period: Number(period),
            expires_in,
            code,
            rateText,
            save_price: Number((o_price - Number(price)).toFixed(2)),
        }
    } else {
        // 无优惠
        obj_data = {
            price: Number(data.price),
            o_price: Number(data.price),
            trial_days: res.trial_days || 0,
            rate: "",
            period: 0,
            expires_in: 0,
            code: null,
            rateText: "",
            save_price: 0,
        }
    }
    obj_data.id = data.id;
    obj_data.activity_id = data.activity_id;

    return obj_data;
}